<footer id="footer-layout-container" *ngIf="tenantConfig$ | async; let tenant">

  <div class="container disclaimer d-flex ">
  
    <div class="flex-fill text">
      <p class="d-flex flex-row button-row">
  
        <a class="btn btn-primary me-3" href="https://www.futuresuper.com.au/contact-us/" target="_blank">Contact us
        </a>
      </p>
      <p>
        All information is general and does not take account of your personal objectives, financial situation or needs.
        Before
        deciding whether a particular product is right for you, please read the relevant Product Disclosure Statement
        including any incorporated information, Target Market Determination and Financial Services Guide available at
        <a href="http://www.futuresuper.com.au/documents-and-forms" target="_blank">Documents and Forms | Future Super</a>
        and consider seeking personal financial advice before making a decision to acquire
        or continue to hold an interest in the product. Future Super does not accept any responsibility for any loss or
        damage
        that may result from reliance on, or the use of, any information contained on this site. The contents of this
        website
        are exclusively owned by Future Super. You must not use or disclose them for any other reason than for the
        purposes
        for which they were supplied.
      </p>
      <p>
        Interests in Future Super are issued by Equity Trustees Superannuation Limited ABN 50 055 641 757, RSE Licence
        L0001458, AFSL 229757 as Trustee of the Smart Future Trust ABN 68 964 712 340 (the Fund). Future Super is a product in the Fund. 
        The Trustee does not in any way endorse, warrant, or accept responsibility for any services provided
        by
        the Promoter in its own right or directly to members or prospective members. Learn more about our Trustee
        including
        their Privacy Statement <a href="https://www.eqt.com.au/superannuation/board-and-governance"
          target="_blank">here</a>.
      </p>
      <p>
        The Promoter of the Fund is Future Super Services Pty Ltd ABN 88 652 577 930, AFS Representative No. 001312077,
        which
        is a corporate authorised representative of Future Group Financial Services Pty Ltd ABN 90 167 800 580; AFSL
        482684
        (FGFS). Contact us about the intra-fund advice services you may be able to access through your membership. Any
        intra-fund advice is provided by or on behalf of FGFS.
      </p>
      <p>
        The Fund is administered by APEX Superannuation (Australia) Pty Ltd ABN 28 081 966 243; AFSL 238507. Insurance cover is 
        provided to eligible members by MetLife Insurance Limited ABN 75 004 274 882; AFS Licence No. 238096. The Investment Manager
        is
        Future Group Investment Management Pty Ltd ABN 55 321 040 702; AFS Representative No. 001271441 which is a
        Corporate
        Authorised Representative of FGFS.
      </p>
      <p>
        You should consider the different fees and costs, amount of insurance cover offered and any other relevant
        information
        before deciding to transfer your super. Past performance is not a reliable indicator of future performance.
      </p>
  
    </div>
  
  
  </div>
  <div class="d-flex {{screenWidth>992?'flex-row':'flex-column'}} w-100 container mt-4">
    <p class="flex-fill"><a target="_blank" href="https://www.futuresuper.com.au/fund-information"
        class="svelte-ooulvi">Fund Information</a>
      <span class="dot svelte-ooulvi">&nbsp;&nbsp;•&nbsp;&nbsp;</span> <a target="_blank"
        href="https://www.futuresuper.com.au/terms-and-conditions" class="svelte-ooulvi">Terms &amp; Conditions</a>
      <span class="dot svelte-ooulvi">&nbsp;&nbsp;•&nbsp;&nbsp;</span> <a target="_blank"
        href="https://www.futuresuper.com.au/privacy-policy" class="svelte-ooulvi">Privacy Policy</a> <span
        class="dot svelte-ooulvi">&nbsp;&nbsp;•&nbsp;&nbsp;</span> <a target="_blank"
        href="https://www.futuresuper.com.au/complaints" class="svelte-ooulvi">Complaints</a>
    </p>
    <div class="d-flex flex-row">
      <p class="svelte-ooulvi"><span class="bold">ABN</span> ‍{{tenant.fundABN}}
        <span class="dot svelte-ooulvi">&nbsp;&nbsp;</span>
      </p>
      <p class="svelte-ooulvi"><span class="bold">USI</span>‍ {{tenant.fundUSI}}</p>
    </div>
  </div>
</footer>